import _ from 'lodash';

import {
  SUPPORTED_FORM_UPLOAD_DOCUMENT_TYPES,
  SUPPORTED_FORM_UPLOAD_IMAGE_TYPES,
  FORBIDDEN_FORM_UPLOAD_TYPES,
  IANA_TYPES,
} from './constants';

type AcceptParams = {
  acceptDocuments: boolean;
  acceptImages: boolean;
  acceptCustom: boolean;
  customTypes: string;
};

const toString = (typeList: Array<string>): string =>
  // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"image/*" | "audio/*" | "video/*"'.
  typeList.map((s) => (IANA_TYPES.includes(s) ? s : `.${s}`)).join(', ');

export const supportedDocumentsTypes = toString(
  // @ts-expect-error - TS2345 - Argument of type 'readonly ["ai", "doc", "docx", "indd", "key", "numbers", "pps", "ppt", "pptx", "psd", "ods", "odt", "odp", "pages", "pdf", "txt", "xls", "xlsx"]' is not assignable to parameter of type 'string[]'.
  SUPPORTED_FORM_UPLOAD_DOCUMENT_TYPES
);
// @ts-expect-error - TS2345 - Argument of type 'readonly ["bmp", "dng", "eps", "gif", "jpg", "jpeg", "png", "ps", "raw", "svg", "tga", "tif", "tiff"]' is not assignable to parameter of type 'string[]'.
export const supportedImagesTypes = toString(SUPPORTED_FORM_UPLOAD_IMAGE_TYPES);

const extractCustomTypes = (customString: string): Array<string> => {
  const types = customString.split(/[\s,\n]+/); // Split by space, comma, new line
  const cleanTypeList = types.reduce<Array<any>>((cleanTypes, type) => {
    const cleanType = _.trim(type.replace(/\s/g, ''), '.').toLowerCase();
    if (cleanType !== '') {
      cleanTypes.push(cleanType);
    }
    return cleanTypes;
  }, []);

  const acceptedTypes = cleanTypeList.filter(
    (type) => !FORBIDDEN_FORM_UPLOAD_TYPES.includes(type)
  );

  return acceptedTypes;
};

export const buildAcceptString = (params: AcceptParams): string => {
  let accept: Array<string> = [];
  if (params.acceptDocuments) {
    accept = accept.concat(SUPPORTED_FORM_UPLOAD_DOCUMENT_TYPES);
  }
  if (params.acceptImages) {
    accept = accept.concat(SUPPORTED_FORM_UPLOAD_IMAGE_TYPES);
  }
  if (params.acceptCustom) {
    accept = accept.concat(extractCustomTypes(params.customTypes));
  }
  return toString(_.uniq(accept));
};
